module.exports = __webpack_public_path__ + "static/img/sec3-content02-img04@tw.34c686e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ybTour/sec3-content02-img04@tw.jpg
// module id = Rske
// module chunks = 0